import { EBreakpoint } from '@/enums/breakpoint';
import { EWindowSize } from '@/enums/window-size';

export function isWindowSize(windowSize: EWindowSize): boolean {
  const width: number = window.innerWidth;
  const height: number = window.innerHeight;
  const portrait: boolean = width < height;

  switch (windowSize) {
    case EWindowSize.XSmall:
      return width <= EBreakpoint.XSmall || (!portrait && height <= EBreakpoint.XSmall);
    case EWindowSize.Small:
      return width <= EBreakpoint.Small;
    case EWindowSize.Medium:
      return width <= EBreakpoint.Medium;
    case EWindowSize.Large:
      return width > EBreakpoint.Medium;
    case EWindowSize.XLarge:
      return width > EBreakpoint.Large;
  }
}
